import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useApi } from "../../../hooks/useApi";
import { clearSession, getRefreshToken } from "../../../utils/session";

export default function SignOut() {
  const navigate = useNavigate();
  const { user } = useApi();

  useEffect(() => {
    // Best-effort server-side revoke of the refresh token — logout must
    // still work client-side even if this call fails (offline, expired, etc).
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      user.logout(refreshToken).catch(() => {});
    }

    clearSession();

    // Redirect to login after a short delay
    const timer = setTimeout(() => {
      navigate("/authentication/sign-in", { replace: true });
    }, 1200);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
    >
      <CircularProgress color="primary" />
      <Typography variant="h6" mt={2}>
        Signing you out...
      </Typography>
    </Box>
  );
}
